import React, { useContext, useRef } from "react";
import { Button, Modal } from "antd";
import WaypointModalContent from "./WaypointModalContent";
import { WaypointModalContext } from "../../CreateRoutes";

export const WaypointModal = ({ visible, isLoaded }) => {
  const modal = useContext(WaypointModalContext);
  return (
    <Modal
      destroyOnClose
      width={600}
      visible={visible}
      closeIcon={<></>}
      title="Add Waypoint"
      footer={false}
    >
      {visible && isLoaded && (
        <WaypointModalContent visible={visible} loaded={isLoaded} />
      )}
    </Modal>
  );
};

export default WaypointModal;
